module.exports = __webpack_public_path__ + "static/media/dist-banner-approvement.03630215.jpeg";